module.exports = __webpack_public_path__ + "static/parade-2020-house12-909f5abbfd80a5e8045047b1475299f7.jpg";